// extracted by mini-css-extract-plugin
export default {"content":"NotFound_content__Ws62g","icon":"NotFound_icon__miQYm","title":"NotFound_title__gCFm6","text":"NotFound_text__EgZ6V","button":"NotFound_button__jKEs4"};